import { render, staticRenderFns } from "./Abschluss.vue?vue&type=template&id=4c0e044a&"
import script from "./Abschluss.vue?vue&type=script&lang=js&"
export * from "./Abschluss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports